import { HttpParams } from '@angular/common/http';
import { OffsetPaginationEvent } from '@crczp/utils';
import { QueryParam } from './query-param';

export class ParamsBuilder {
    /**
     * Transforms filters to http params in server supported format
     * @param filters filters to transform into http params
     */
    static queryParams(filters?: QueryParam[]): HttpParams {
        let params = new HttpParams();
        if (!filters) {
            return params;
        }
        filters.forEach(
            (filter) =>
                (params = params.set(filter.name, filter.value.toString())),
        );
        return params;
    }

    /**
     * Transforms requested pagination object to http params in trainings microservice format (JAVA API)
     * @param pagination requested pagination
     */
    static javaPaginationParams<T extends Record<string, never>>(
        pagination: OffsetPaginationEvent<Extract<keyof T, string>>,
    ): HttpParams {
        if (pagination) {
            if (pagination.sort) {
                const sort =
                    pagination.sort +
                    ',' +
                    (pagination.sortDir ? pagination.sortDir : 'asc');
                return new HttpParams()
                    .set('page', pagination.page.toString())
                    .set('size', pagination.size.toString())
                    .set('sort', sort);
            } else {
                return new HttpParams()
                    .set('page', pagination.page.toString())
                    .set('size', pagination.size.toString());
            }
        }
        return new HttpParams().set('page', '0').set('size', '10');
    }

    /**
     * Transforms requested pagination object to http params in sandbox microservice format (PYTHON API).
     * A missing page or page size falls back to the first page of the default size, a missing sort
     * direction to ascending.
     * @param pagination requested pagination
     */
    static djangoPaginationParams<T extends Record<string, never>>(
        pagination: OffsetPaginationEvent<Extract<keyof T, string>> | undefined,
    ): HttpParams {
        const params = new HttpParams()
            .set('page', ((pagination?.page ?? 0) + 1).toString()) // + 1 because sandbox microservice pages starts with 1 instead of 0
            .set('page_size', (pagination?.size ?? 10).toString());
        return pagination?.sort
            ? params
                  .set('sort_by', pagination.sort)
                  .set('order', pagination.sortDir ?? 'asc')
            : params;
    }
}
